import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { Row, Col, Card, Modal, Button, Input, message, Table } from "antd";
import { CalendarTwoTone, SearchOutlined } from "@ant-design/icons";
import {
    Get_KiiValuesFormDateToDate,
    GET_User_Details_User_Management,
    Get_User_Last_Active_Status,
    Get_User_Profile,
    Get_User_Performance_Data_For_Months,
    CREATE_NEW_WEB_NOTIFICATION,
    GET_USER_NOTIFICATIONS,
    Remove_User,
    GET_ATTENDANCE_DETAILS,
    Get_User_Value_For_Project_Time,
    Role_Account_Query,
    GET_User_Details_User_Management_For_UserProfile,
} from "../../services/userAPI";
import { PieChart, Pie as RechartsPie, Cell, Tooltip, Legend } from "recharts";
import backIcon from "../../Images/addstarsbackIcon.png";
import UserProfileIcon from "../../Images/userProfileIcon.png";
import UserProfileUserIcon from "../../Images/userProfileUserIcon.png";
import PaginationPrevious from "../../Images/paginationPreviuosIcon.png";
import PaginationNext from "../../Images/paginationNextIcon.png";
import ProfileImageUploader from "../../components/profileImageUploader";
import { ReactComponent as PresentDays } from "../../Images/presentDaysIcon.svg";
import { ReactComponent as ComplianceDays } from "../../Images/complianceDaysIcon.svg";
import { ReactComponent as SignedInIcon } from "../../Images/signedInIcon.svg";
import { ReactComponent as SignedDisableIcon } from "../../Images/signedInDisableIcon.svg";
import { ReactComponent as SignedOutIcon } from "../../Images/signedOutIcon.svg";
import { ReactComponent as WorkedDataIcon } from "../../Images/workedDataIcon.svg";
import { ReactComponent as WorkedDataIconDisable } from "../../Images/workedDataIconDisable.svg";
import { ReactComponent as TimeDistributionIcon } from "../../Images/timeDistributionIcon.svg";
import { ReactComponent as TimeDistributionIconDisable } from "../../Images/timeDistributionIconDisable.svg";
import { ReactComponent as LeaveIcon } from "../../Images/leaveIconActivate.svg";
import { ReactComponent as LeaveIconDisable } from "../../Images/leaveIconDisable.svg";
import { ReactComponent as HolidayIconActivate } from "../../Images/holidayIconActivate.svg";
import { ReactComponent as HolidayIconDisable } from "../../Images/holidayIconDisable.svg";
import EditUserModal from "../../components/Dashboard/Darts/masterConfiguration/userManagement/editUserModal";
import PushVideosFromAdminPanel from "./../pushVideosFromAdminPanel";
import AdvancedNotificationModal from './clanCrewAdvancedNotificationModal';
import ClanCrewAdvancedNotificationModal from "./clanCrewAdvancedNotificationModal";
import NotificationSystem from "./notificationSystem";
import { User } from "lucide-react";
import ClanCrewUnderstandUserProfile from "./clanCrewUnderstandUserProfile";
import SendNotificationModal from "../sendNotificationModal";

const ClanCrewUserProfile = () => {
    const parseRoleId = (roleId) => {
        const parsed = parseInt(roleId, 10);
        return isNaN(parsed) ? null : parsed;
    };

    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams(); // Get userId from URL

    const [isPageLoading, setIsPageLoading] = useState(true);

    // State for selected user
    const [selectedUserId, setSelectedUserId] = useState(parseInt(id) || null);
    const [localProfilePicture, setLocalProfilePicture] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isNotificationVisible, setIsNotificationVisible] = useState(false);
    const [isNotificationHistoryVisible, setIsNotificationHistoryVisible] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationDetails, setNotificationDetails] = useState("");
    const [cropVisible, setCropVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [cursors, setCursors] = useState([]);
    const [limit] = useState(10);

    // Scroll position refs
    const scrollRef = useRef(null);
    const userListScrollRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [userListScrollPosition, setUserListScrollPosition] = useState(0);

    const name = location.state?.name;
    const accountName = location.state?.accountName;
    const rawRoleId = location.state?.roleId;
    const accountId = location.state?.accountId || localStorage.getItem("accountId") || null;
    const roleId = parseRoleId(rawRoleId);

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const today = currentDate.toISOString().split("T")[0];

    // State for Attendance Summary
    const [activeFilterAttendance, setActiveFilterAttendance] = useState("This month");
    const [showDateRangePopupAttendance, setShowDateRangePopupAttendance] = useState(false);
    const [dateRangeAttendance, setDateRangeAttendance] = useState({ from: "", to: "" });
    const [appliedDateRangeAttendance, setAppliedDateRangeAttendance] = useState({ from: "", to: "" });

    // State for Lead Indicator Data
    const [activeFilterLead, setActiveFilterLead] = useState("This month");
    const [showDateRangePopupLead, setShowDateRangePopupLead] = useState(false);
    const [dateRangeLead, setDateRangeLead] = useState({ from: "", to: "" });
    const [appliedDateRangeLead, setAppliedDateRangeLead] = useState({ from: "", to: "" });

    // State for Performance Data
    const [activeFilterPerformance, setActiveFilterPerformance] = useState("This month");
    const [showDateRangePopupPerformance, setShowDateRangePopupPerformance] = useState(false);
    const [dateRangePerformance, setDateRangePerformance] = useState({ from: "", to: "" });
    const [appliedDateRangePerformance, setAppliedDateRangePerformance] = useState({ from: "", to: "" });

    const [isPushVideosModalVisible, setIsPushVideosModalVisible] = useState(false);

    const [isAdvancedNotifVisible, setIsAdvancedNotifVisible] = useState(false);
    const [isNotificationSystem, setIsNotificationSystem] = useState(false);

    const [isUnderstandUserModalVisible, setIsUnderstandUserModalVisible] = useState(false);

    const [showSendNotificationModal, setShowSendNotificationModal] = useState(false);

    const renderLoading = () => (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%'
        }}>
            <div className="loading-container">
                <div className="spinner-loader"></div>
            </div>
        </div>
    );

    // Save scroll positions
    const saveScrollPosition = () => {
        if (scrollRef.current) {
            setScrollPosition(scrollRef.current.scrollTop);
        }
    };

    const saveUserListScrollPosition = () => {
        if (userListScrollRef.current) {
            const currentScroll = userListScrollRef.current.scrollTop;
            setUserListScrollPosition(currentScroll);
            sessionStorage.setItem(`userListScroll_${roleId}`, currentScroll.toString());
        }
    };

    const getDateRange = (filterType, customDateRange = null) => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();
        const today = now.toISOString().split("T")[0];

        switch (filterType) {
            case "This month":
                const startOfCurrentMonth = new Date(Date.UTC(currentYear, currentMonth, 1)).toISOString().split("T")[0];
                return {
                    startDate: startOfCurrentMonth,
                    endDate: today
                };
            case "Last month":
                const lastMonthStart = new Date(Date.UTC(currentYear, currentMonth - 1, 1, 0, 0, 0, 0));
                const lastMonthEnd = new Date(Date.UTC(currentYear, currentMonth, 0, 23, 59, 59, 999));
                return {
                    startDate: lastMonthStart.toISOString().split("T")[0],
                    endDate: lastMonthEnd.toISOString().split("T")[0],
                };
            case "Last 3 months":
                const threeMonthsAgoStart = new Date(Date.UTC(currentYear, currentMonth - 3, 1, 0, 0, 0, 0));
                const threeMonthsAgoEnd = new Date(Date.UTC(currentYear, currentMonth, 0, 23, 59, 59, 999));
                return {
                    startDate: threeMonthsAgoStart.toISOString().split("T")[0],
                    endDate: threeMonthsAgoEnd.toISOString().split("T")[0],
                };
            case "Last 6 months":
                const sixMonthsAgoStart = new Date(Date.UTC(currentYear, currentMonth - 6, 1, 0, 0, 0, 0));
                const sixMonthsAgoEnd = new Date(Date.UTC(currentYear, currentMonth, 0, 23, 59, 59, 999));
                return {
                    startDate: sixMonthsAgoStart.toISOString().split("T")[0],
                    endDate: sixMonthsAgoEnd.toISOString().split("T")[0],
                };
            case "Last Year":
                const lastYearStart = new Date(Date.UTC(currentYear - 1, 0, 1, 0, 0, 0, 0));
                const lastYearEnd = new Date(Date.UTC(currentYear - 1, 11, 31, 23, 59, 59, 999));
                return {
                    startDate: lastYearStart.toISOString().split("T")[0],
                    endDate: lastYearEnd.toISOString().split("T")[0],
                };
            case "Custom":
                const startOfCurrentMonthForCustom = new Date(Date.UTC(currentYear, currentMonth, 1, 0, 0, 0, 0)).toISOString().split("T")[0];
                return {
                    startDate: customDateRange?.from || startOfCurrentMonthForCustom,
                    endDate: customDateRange?.to || today,
                };
            default:
                const defaultStartOfMonth = new Date(Date.UTC(currentYear, currentMonth, 1, 0, 0, 0, 0)).toISOString().split("T")[0];
                return {
                    startDate: defaultStartOfMonth,
                    endDate: today
                };
        }
    };

    const getDateRangeAttendance = useMemo(() => {
        return getDateRange(activeFilterAttendance, appliedDateRangeAttendance);
    }, [activeFilterAttendance, appliedDateRangeAttendance.from, appliedDateRangeAttendance.to]);

    const getDateRangeLead = useMemo(() => {
        return getDateRange(activeFilterLead, appliedDateRangeLead);
    }, [activeFilterLead, appliedDateRangeLead.from, appliedDateRangeLead.to]);

    const getDateRangePerformance = useMemo(() => {
        return getDateRange(activeFilterPerformance, appliedDateRangePerformance);
    }, [activeFilterPerformance, appliedDateRangePerformance.from, appliedDateRangePerformance.to]);

    const { data: profileData, loading: profileLoading, error: profileError, refetch: refetchProfile } = useQuery(
        Get_User_Profile,
        {
            variables: { userId: selectedUserId },
            fetchPolicy: "cache-and-network",
            skip: !selectedUserId,
            onCompleted: () => {
                // When profile data is loaded, update the loading state
                setIsPageLoading(false);
            },
            onError: () => {
                // If there's an error, also update the loading state
                setIsPageLoading(false);
            }
        }
    );

    const [loadUsers, { data: userListData, loading: userListLoading, error: userListError, fetchMore }] = useLazyQuery(
        GET_User_Details_User_Management_For_UserProfile,
        {
            fetchPolicy: "cache-and-network",
            onCompleted: () => {
                // When user list is loaded, update the loading state
                if (profileData) {
                    setIsPageLoading(false);
                }
            },
            onError: () => {
                // If there's an error, also update the loading state
                setIsPageLoading(false);
            }
        }
    );

    // 2. Add these states (add near your other useState)
    const [allUsers, setAllUsers] = useState([]);
    const [userListCursor, setUserListCursor] = useState(null);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        if (!roleId) return;

        // Reset everything when role changes
        setAllUsers([]);
        setUserListCursor(null);
        setHasNextPage(true);

        loadUsers({
            variables: {
                roleId,
                pagingCriteria: {
                    limit: 1500,
                    cursor: null,
                },
            },
        });
    }, [roleId, loadUsers]);

    useEffect(() => {
        if (userListData?.getUsersForAccount?.data) {
            const newUsers = userListData.getUsersForAccount.data;
            const pageMeta = userListData.getUsersForAccount.pageMeta;

            setAllUsers(prev => {
                // Prevent duplicates on refresh
                const existingIds = new Set(prev.map(u => u.id));
                const filtered = newUsers.filter(u => !existingIds.has(u.id));
                return [...prev, ...filtered];
            });

            // setUserListCursor(pageMeta.nextPage);
            // setHasNextPage(pageMeta.hasNextPage);
        }
    }, [userListData]);

    // Apply client-side filtering based on searchTerm
    const filteredUsers = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return allUsers;
        return allUsers.filter((u) => (u.name || "").toLowerCase().includes(term));
    }, [allUsers, searchTerm]);

    const handleUserListScroll = () => {
        if (!userListScrollRef.current || loadingMore || !hasNextPage) return;

        const { scrollTop, scrollHeight, clientHeight } = userListScrollRef.current;

        if (scrollHeight - scrollTop - clientHeight < 300) { // Trigger 300px from bottom
            setLoadingMore(true);

            fetchMore({
                variables: {
                    roleId,
                    pagingCriteria: {
                        limit: 50,
                        cursor: userListCursor,
                    },
                },
            }).then((fetchMoreResult) => {
                setLoadingMore(false);

                if (fetchMoreResult.data?.getUsersForAccount) {
                    const newUsers = fetchMoreResult.data.getUsersForAccount.data;
                    const pageMeta = fetchMoreResult.data.getUsersForAccount.pageMeta;

                    setAllUsers(prev => [...prev, ...newUsers]);
                    setUserListCursor(pageMeta.nextPage);
                    setHasNextPage(pageMeta.hasNextPage);
                }
            }).catch(() => {
                setLoadingMore(false);
            });
        }
    };

    useEffect(() => {
        const scrollEl = userListScrollRef.current;
        if (!scrollEl) return;

        const listener = () => handleUserListScroll();
        scrollEl.addEventListener("scroll", listener);

        return () => scrollEl.removeEventListener("scroll", listener);
    }, [userListCursor, hasNextPage, loadingMore, roleId]);


    const { data: jobRoleData, loading: jobRoleLoading, error: jobRoleError } = useQuery(Role_Account_Query, {
        fetchPolicy: "cache-and-network",
        variables: { accountId: parseInt(accountId), roleId: parseInt(roleId) },
        skip: !roleId, // Skip if roleId is not available
    });


    const showPushVideos = useMemo(() => {
        if (jobRoleLoading || jobRoleError || !jobRoleData?.getAllJobrole) return false;
        const userRole = jobRoleData.getAllJobrole.find((role) => role.id === roleId);
        return userRole ? userRole.clanNeeded : false;
    }, [jobRoleData, jobRoleLoading, jobRoleError, roleId]);

    useEffect(() => {
        const savedScroll = sessionStorage.getItem(`userListScroll_${roleId}`);
        if (savedScroll) {
            setUserListScrollPosition(parseFloat(savedScroll));
        }
    }, [roleId]);

    const {
        data: projectTimeData,
        loading: projectTimeLoading,
        error: projectTimeError,
        refetch: refetchProjectTime,
    } = useQuery(Get_User_Value_For_Project_Time, {
        variables: {
            userId: selectedUserId,
            startDate: getDateRangeLead.startDate,
            endDate: getDateRangeLead.endDate,
        },
        fetchPolicy: "cache-and-network",
        skip: !selectedUserId,
    });

    const formatSecondsToTime = (seconds) => {
        if (!seconds || isNaN(seconds)) return "00:00";
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        return [
            hours.toString().padStart(2, "0"),
            minutes.toString().padStart(2, "0"),
            // remainingSeconds.toString().padStart(2, "0"),
        ].join(":");
    };

    const sortedProjectTimeData = projectTimeData?.getUserValueForProjectTimeForATimePeriod
        ? [...projectTimeData.getUserValueForProjectTimeForATimePeriod].sort((a, b) => {
            const aHasDepends = Array.isArray(a.depends) && a.depends.length > 0;
            const bHasDepends = Array.isArray(b.depends) && b.depends.length > 0;
            if (aHasDepends && !bHasDepends) return -1; // a comes first
            if (!aHasDepends && bHasDepends) return 1; // b comes first
            return 0; // maintain original order
        })
        : [];

    const {
        data: lastActiveData,
        loading: lastActiveLoading,
        error: lastActiveError,
        startPolling,
        stopPolling,
        refetch: refetchLastActive,
    } = useQuery(Get_User_Last_Active_Status, {
        variables: { userId: selectedUserId },
        fetchPolicy: "cache-and-network",
        skip: !selectedUserId,
    });

    const {
        data: leadIndicatorData,
        loading: leadIndicatorDataLoading,
        error: leadIndicatorDataError,
        refetch: refetchLeadIndicator,
    } = useQuery(Get_KiiValuesFormDateToDate, {
        variables: {
            accountId: parseInt(accountId),
            jobroleId: parseInt(roleId),
            userId: selectedUserId,
            startDate: getDateRangeLead.startDate,
            endDate: getDateRangeLead.endDate,
        },
        fetchPolicy: "cache-and-network",
        skip: !accountId || !roleId || !selectedUserId,
    });

    const {
        data: attendanceData,
        loading: attendanceLoading,
        error: attendanceError,
        refetch: refetchAttendance,
    } = useQuery(GET_ATTENDANCE_DETAILS, {
        variables: { userId: selectedUserId, startDate: getDateRangeAttendance.startDate, endDate: getDateRangeAttendance.endDate },
        fetchPolicy: "cache-and-network",
        skip: !selectedUserId,
    });

    const {
        data: performanceData,
        loading: performanceLoading,
        error: performanceError,
        refetch: refetchPerformance,
    } = useQuery(Get_User_Performance_Data_For_Months, {
        variables: { userId: selectedUserId, fromMonth: getDateRangePerformance.startDate, toMonth: getDateRangePerformance.endDate },
        fetchPolicy: "cache-and-network",
        skip: !selectedUserId,
    });

    const [fetchNotifications, { data: notificationData, loading: notificationLoading, error: notificationError }] =
        useLazyQuery(GET_USER_NOTIFICATIONS, {
            variables: {
                userId: selectedUserId,
                pagingCriteria: { limit, cursor: cursor || undefined, sortByField: "created_at", sortOrder: "desc" },
            },
            fetchPolicy: "cache-and-network",
            skip: !selectedUserId,
        });

    const [createNotification, { loading: createNewNotificationLoading }] = useMutation(CREATE_NEW_WEB_NOTIFICATION);

    const [removeUserMutation, { loading, error, data }] = useMutation(Remove_User, {
        variables: { userId: selectedUserId },
        onCompleted: (data) => {
            if (data.removeUser.success) {
                message.success("User removed successfully!");
                if (userListData?.getUsersForAccount?.data) {
                    const users = [...userListData.getUsersForAccount.data].sort((a, b) => a.id - b.id);
                    const firstUser = users[0];
                    if (firstUser) {
                        navigate(`/clan-crew-user-profile/${firstUser.id}`, {
                            state: { name, accountName, roleId, accountId },
                        });
                        setSelectedUserId(firstUser.id);
                    } else {
                        navigate("/clan-crew-user-management", { state: { name, accountName, roleId, accountId } });
                    }
                } else {
                    navigate("/clan-crew-user-management", { state: { name, accountName, roleId, accountId } });
                }
            } else {
                message.error(`Failed to remove user: ${data.removeUser.message}`);
            }
        },
        onError: (error) => {
            message.error(`Error removing user: ${error.message}`);
        },
    });

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleRemoveProfile = () => {
        setShowConfirmModal(true);
    };

    const handleConfirmRemove = () => {
        setShowConfirmModal(false);
        removeUserMutation();
    };

    const handleCancelRemove = () => {
        setShowConfirmModal(false);
    };

    const calculateAge = (dateOfBirth) => {
        if (!dateOfBirth) return '';

        let birthDate;

        // ---- 1. Parse the incoming string ---------------------------------
        if (dateOfBirth.includes('/')) {
            // DD/MM/YYYY
            const [d, m, y] = dateOfBirth.split('/').map(Number);
            if (isNaN(d) || isNaN(m) || isNaN(y)) return '';
            birthDate = new Date(y, m - 1, d);               // month is 0-based
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateOfBirth)) {
            // YYYY-MM-DD
            birthDate = new Date(dateOfBirth);
        } else {
            return '';
        }

        if (isNaN(birthDate.getTime())) return '';

        // ---- 2. Normalise to midnight (ignore time part) ------------------
        const today = new Date();
        const birth = new Date(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
        const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        // ---- 3. If birthday is in the future --------------------------------
        if (birth > now) return 'Not born yet';

        // ---- 4. Calculate full years only ----------------------------------
        let years = now.getFullYear() - birth.getFullYear();

        // Subtract 1 year if birthday hasn't occurred this year yet
        const thisYearsBirthday = new Date(now.getFullYear(), birth.getMonth(), birth.getDate());
        if (thisYearsBirthday > now) {
            years--;
        }

        return years === 1 ? '1 year' : `${years} years`;
    };

    const calculateYearsOfService = (joiningDate) => {
        if (!joiningDate) return "";

        let joinDate;

        // Case 1: DD/MM/YYYY format (e.g., "01/10/2025")
        if (joiningDate.includes('/')) {
            const [day, month, year] = joiningDate.split('/').map(Number);
            if (isNaN(day) || isNaN(month) || isNaN(year)) return "";
            joinDate = new Date(year, month - 1, day);
        }
        // Case 2: ISO format (e.g., "2025-10-01")
        else if (/^\d{4}-\d{2}-\d{2}$/.test(joiningDate)) {
            joinDate = new Date(joiningDate);
        }
        // Invalid format
        else {
            return "";
        }

        if (isNaN(joinDate.getTime())) return "";

        const today = new Date();
        const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const join = new Date(joinDate.getFullYear(), joinDate.getMonth(), joinDate.getDate());

        // If joining in future
        if (join > now) {
            return "Not joined yet";
        }

        // Calculate years
        let years = now.getFullYear() - join.getFullYear();

        // Calculate months
        let months = now.getMonth() - join.getMonth();
        if (months < 0) {
            years--;
            months += 12;
        }

        // Adjust if day hasn't reached yet
        if (now.getDate() < join.getDate()) {
            months--;
            if (months < 0) {
                years--;
                months += 12;
            }
        }

        // Calculate remaining days
        let days;
        if (now.getDate() >= join.getDate()) {
            days = now.getDate() - join.getDate();
        } else {
            // Previous month
            const lastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
            const daysInPrevMonth = lastMonth.getDate();
            days = now.getDate() + (daysInPrevMonth - join.getDate());
        }

        // Build result
        const parts = [];

        if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
        if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);

        // If less than a day (shouldn't happen, but safe)
        if (parts.length === 0) {
            const diffTime = Math.abs(now - join);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            return diffDays === 0 ? "0 days" : `${diffDays} day${diffDays > 1 ? 's' : ''}`;
        }

        return parts.join(' ');
    };
    const [totalPerformance, setTotalPerformance] = useState(0);
    const [pieData, setPieData] = useState([]);

    const [attendanceSummary, setAttendanceSummary] = useState({
        presentDays: 0,
        complianceDays: 0,
        daysOnLeave: 0,
        holidays: 0,
    });

    useEffect(() => {
        const processPerformanceData = (data) => {
            if (!data?.getUserPerformanceDataForMonths || data.getUserPerformanceDataForMonths.length === 0) {
                return { total: 0, pieData: [] };
            }

            const labelCounts = data.getUserPerformanceDataForMonths.reduce(
                (acc, item) => {
                    const label = item.performanceLabel?.toUpperCase() || "UNKNOWN";
                    acc[label] = (acc[label] || 0) + 1;
                    return acc;
                },
                { HIGH: 0, MEDIUM: 0, LOW: 0, UNKNOWN: 0 }
            );

            const total = data.getUserPerformanceDataForMonths.length;
            const pieData = [
                { name: "Low Performance", value: (labelCounts.LOW / total) * 100, fill: "#D73838" },
                { name: "Medium Performance", value: (labelCounts.MEDIUM / total) * 100, fill: "#2E96FF" },
                { name: "High Performance", value: (labelCounts.HIGH / total) * 100, fill: "#49A44A" },
            ].filter((item) => item.value > 0);

            return { total, pieData };
        };

        const { total, pieData: newPieData } = processPerformanceData(performanceData);
        setTotalPerformance(total);
        setPieData(newPieData);
    }, [performanceData]);

    useEffect(() => {
        if (userListScrollRef.current && !userListLoading && !profileLoading && !attendanceLoading && !leadIndicatorDataLoading && !performanceLoading && !projectTimeLoading) {
            requestAnimationFrame(() => {
                if (userListScrollRef.current) {
                    userListScrollRef.current.scrollTop = userListScrollPosition;
                }
            });
        }
    }, [userListData, userListLoading, selectedUserId, profileLoading, attendanceLoading, leadIndicatorDataLoading, performanceLoading, projectTimeLoading]);

    useEffect(() => {
        if (!attendanceLoading && !attendanceError && attendanceData?.getAttendanceDetailsForATimePeriod) {
            const attendance = Array.isArray(attendanceData.getAttendanceDetailsForATimePeriod)
                ? attendanceData.getAttendanceDetailsForATimePeriod
                : [];
            setAttendanceSummary({
                presentDays: attendance.filter((day) => day.didSignIn).length,
                complianceDays: attendance.filter(
                    (day) => day.didSignIn && day.didInput && day.didSignOut && day.givenTimeDistribution
                ).length,
                daysOnLeave: attendance.filter((day) => day.isLeave).length,
                holidays: attendance.filter((day) => day.isHoliday).length,
            });
        } else {
            setAttendanceSummary({
                presentDays: 0,
                complianceDays: 0,
                daysOnLeave: 0,
                holidays: 0,
            });
        }
    }, [attendanceData, attendanceLoading, attendanceError]);

    useEffect(() => {
        startPolling(30000);
        const handleVisibilityChange = () => {
            if (document.hidden) {
                stopPolling();
            } else {
                startPolling(30000);
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            stopPolling();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [startPolling, stopPolling]);

    // useEffect(() => {
    //     if (roleId) {
    //         fetchUserList({
    //             variables: {
    //                 roleId,
    //                 filterByName: searchTerm || undefined,
    //                 joiningDateFilter: undefined,
    //             },
    //         });
    //     }
    // }, [roleId, searchTerm, fetchUserList]);

    useEffect(() => {
        if (selectedUserId && isNotificationHistoryVisible) {
            fetchNotifications({
                variables: {
                    userId: selectedUserId,
                    pagingCriteria: { limit, cursor: cursor || undefined, sortByField: "created_at", sortOrder: "desc" },
                },
            });
        }
    }, [selectedUserId, cursor, isNotificationHistoryVisible, fetchNotifications]);

    // Update cursors after fetching notifications
    useEffect(() => {
        if (notificationData?.getUserNotifications?.pageMeta?.nextPage) {
            const nextC = notificationData.getUserNotifications.pageMeta.nextPage;
            setCursors((prev) => {
                const last = prev[prev.length - 1];
                if (last !== nextC) {
                    return [...prev, nextC];
                }
                return prev;
            });
        }
    }, [notificationData]);

    // Update URL when selectedUserId changes
    useEffect(() => {
        if (selectedUserId) {
            navigate(`/clan-crew-user-profile/${selectedUserId}`, {
                state: { name, accountName, roleId, accountId },
                replace: true, // Use replace to avoid adding to history stack
            });
        }
    }, [selectedUserId, navigate, name, accountName, roleId, accountId]);

    useEffect(() => {
        if (!selectedUserId) return;

        setActiveFilterAttendance("This month");
        setShowDateRangePopupAttendance(false);
        setDateRangeAttendance({ from: "", to: "" });
        setAppliedDateRangeAttendance({ from: "", to: "" });

        setActiveFilterLead("This month");
        setShowDateRangePopupLead(false);
        setDateRangeLead({ from: "", to: "" });
        setAppliedDateRangeLead({ from: "", to: "" });

        setActiveFilterPerformance("This month");
        setShowDateRangePopupPerformance(false);
        setDateRangePerformance({ from: "", to: "" });
        setAppliedDateRangePerformance({ from: "", to: "" });
        setLocalProfilePicture(null);
    }, [selectedUserId]);

    const handleFilterClickAttendance = (filter) => {
        saveScrollPosition();
        setActiveFilterAttendance(filter === activeFilterAttendance ? null : filter);
        setActiveFilterLead(filter === activeFilterLead ? null : filter);
        setActiveFilterPerformance(filter === activeFilterPerformance ? null : filter);

        if (filter !== "Custom") {
            const { startDate, endDate } = getDateRangeAttendance;
            refetchAttendance({
                variables: { userId: selectedUserId, startDate, endDate },
            });
            refetchLeadIndicator({
                variables: {
                    accountId: parseInt(accountId),
                    jobroleId: parseInt(roleId),
                    userId: selectedUserId,
                    startDate,
                    endDate,
                },
            });
            refetchPerformance({
                variables: { userId: selectedUserId, fromMonth: startDate, toMonth: endDate },
            });
        } else {
            setShowDateRangePopupAttendance(true);
            setShowDateRangePopupLead(true);
            setShowDateRangePopupPerformance(true);
        }
    };

    const handleDateChangeAttendance = (e) => {
        const { name, value } = e.target;
        setDateRangeAttendance((prev) => {
            const newRange = { ...prev, [name]: value };
            if (name === "from" && value > newRange.to && newRange.to) {
                return { ...newRange, to: "" };
            }
            return newRange;
        });
    };

    const handleApplyDateRangeAttendance = () => {
        if (!dateRangeAttendance.from || !dateRangeAttendance.to) {
            message.error("Please select both From and To dates.");
            return;
        }
        if (new Date(dateRangeAttendance.from) > new Date(dateRangeAttendance.to)) {
            message.error("To date must be after From date.");
            return;
        }
        saveScrollPosition();
        setAppliedDateRangeAttendance({ from: dateRangeAttendance.from, to: dateRangeAttendance.to });
        setAppliedDateRangeLead({ from: dateRangeAttendance.from, to: dateRangeAttendance.to });
        setAppliedDateRangePerformance({ from: dateRangeAttendance.from, to: dateRangeAttendance.to });

        refetchAttendance({
            variables: { userId: selectedUserId, startDate: dateRangeAttendance.from, endDate: dateRangeAttendance.to },
        });
        refetchLeadIndicator({
            variables: {
                accountId: parseInt(accountId),
                jobroleId: parseInt(roleId),
                userId: selectedUserId,
                startDate: dateRangeAttendance.from,
                endDate: dateRangeAttendance.to,
            },
        });
        refetchPerformance({
            variables: { userId: selectedUserId, fromMonth: dateRangeAttendance.from, toMonth: dateRangeAttendance.to },
        });

        setShowDateRangePopupAttendance(false);
        setShowDateRangePopupLead(false);
        setShowDateRangePopupPerformance(false);
        setDateRangeAttendance({ from: "", to: "" });
        setDateRangeLead({ from: "", to: "" });
        setDateRangePerformance({ from: "", to: "" });
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (showDateRangePopupAttendance && !e.target.closest(".date-range-popup-attendance")) {
                setShowDateRangePopupAttendance(false);
                setDateRangeAttendance({ from: "", to: "" });
            }
            if (showDateRangePopupLead && !e.target.closest(".date-range-popup-lead")) {
                setShowDateRangePopupLead(false);
                setDateRangeLead({ from: "", to: "" });
            }
            if (showDateRangePopupPerformance && !e.target.closest(".date-range-popup-performance")) {
                setShowDateRangePopupPerformance(false);
                setDateRangePerformance({ from: "", to: "" });
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showDateRangePopupAttendance, showDateRangePopupLead, showDateRangePopupPerformance]);

    const handleCancelAttendance = () => {
        setShowDateRangePopupAttendance(false);
        setDateRangeAttendance({ from: "", to: "" });
    };

    const handleSearchChange = (e) => {
        saveUserListScrollPosition();
        const value = e.target.value;
        setSearchTerm(value);
    };

    const handleUserClick = (userId) => {
        saveScrollPosition();
        saveUserListScrollPosition();
        setSelectedUserId(userId); // Update selected user
    };

    const formatDateToIndian = (dateString) => {
        if (!dateString || dateString === "") return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatTimeToIndian = (dateString) => {
        if (!dateString || dateString === "") return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        const istTime = date.toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
            hour12: true,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return istTime.replace(", ", " ");
    };

    const handleSaveCroppedImage = (croppedImageData) => {
        setLocalProfilePicture(croppedImageData);
        refetchProfile();
    };

    const handleNotificationClick = () => {
        setIsNotificationVisible(true);
    };

    const handlePopupClose = () => {
        setIsPopupVisible(false);
    };

    const handleNotificationClose = () => {
        setIsNotificationVisible(false);
        setNotificationMessage("");
        setNotificationDetails("");
    };

    const handleSendNotification = async () => {
        try {
            if (!notificationMessage.trim() || !notificationDetails.trim()) {
                message.error("Title and description are required.");
                return;
            }

            const variables = {
                data: [
                    {
                        userId: selectedUserId,
                        title: notificationMessage,
                        notificationType: "WEBADMIN",
                        referenceId: 0,
                        description: notificationDetails,
                    },
                ],
            };

            const response = await createNotification({ variables });

            if (response.data.createNewWebNotification.success) {
                message.success("Notification sent successfully!");
                handleNotificationClose();
            } else {
                message.error(`Failed to send notification: ${response.data.createNewWebNotification.message}`);
            }
        } catch (error) {
            message.error(`Error sending notification: ${error.message}`);
        }
    };

    const handleNotificationHistoryClick = () => {
        setIsNotificationHistoryVisible(true);
        setCursor(null);
        setCursors([null]);
        setCurrentPage(1);
    };

    const handleNotificationHistoryClose = () => {
        setIsNotificationHistoryVisible(false);
        setCursor(null);
        setCursors([]);
        setCurrentPage(1);
    };

    const notificationColumns = [
        { title: "Title", dataIndex: "title", key: "title" },
        { title: "Description", dataIndex: "description", key: "description" },
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (dateString) => formatDateToIndian(dateString),
        },
        {
            title: "Time",
            dataIndex: "createdAt",
            key: "time",
            render: (dateString) => formatTimeToIndian(dateString),
        },
        {
            title: "Sender",
            dataIndex: ["eventInitiator", "name"],
            key: "initiator",
            render: (_, record) => {
                const name = record?.eventInitiator?.name;
                const surname = record?.eventInitiator?.surname;

                const fullName = [name, surname]
                    .filter(Boolean)
                    .map(str => str.charAt(0).toUpperCase() + str.slice(1))
                    .join(" ");

                return fullName || "-";
            },
        },
    ];

    const notificationDataSource = notificationData?.getUserNotifications?.data || [];
    const nextCursor = notificationData?.getUserNotifications?.pageMeta?.nextPage;
    const hasNext = notificationData?.getUserNotifications?.pageMeta?.hasNextPage || false;

    const [currentPage, setCurrentPage] = useState(1);
    const totalItems = notificationData?.getUserNotifications?.pageMeta?.totalCount || 0;
    const totalPages = Math.ceil(totalItems / limit);

    const handlePageChange = (direction) => {
        if (direction === "next" && hasNext) {
            setCursor(nextCursor);
            setCurrentPage((prev) => prev + 1);
        } else if (direction === "prev" && currentPage > 1) {
            const prevIndex = currentPage - 2;
            const prevCursor = cursors[prevIndex];
            setCursor(prevCursor);
            setCurrentPage((prev) => prev - 1);
        }
    };

    // const isLoading =
    //     profileLoading ||
    //     lastActiveLoading ||
    //     leadIndicatorDataLoading ||
    //     attendanceLoading ||
    //     performanceLoading ||
    //     notificationLoading ||
    //     projectTimeLoading;
    const hasError =
        profileError ||
        lastActiveError ||
        leadIndicatorDataError ||
        attendanceError ||
        performanceError ||
        notificationError ||
        projectTimeError;

    const leadIndicatorDataResult = leadIndicatorData?.getKiiValuesFormDateToDate || [];
    const user = profileData?.userProfile;
    const isManagerOrSuperManager = user?.userType?.userType === "Immediate Supervisor" || user?.userType?.userType === "Super Manager";
    const status = lastActiveLoading
        ? "Loading..."
        : lastActiveError
            ? "Error"
            : lastActiveData?.getUserLastActiveStatus || "Unknown";
    let statusDotClass = "inactive";
    if (status === "Online") {
        statusDotClass = "active";
    } else if (typeof status === "string" && status.startsWith("Online")) {
        statusDotClass = "recent-online";
    }

    // Restore scroll positions
    useEffect(() => {
        if (scrollRef.current && !profileLoading && !attendanceLoading && !leadIndicatorDataLoading && !performanceLoading) {
            scrollRef.current.scrollTop = scrollPosition;
        }
    }, [profileData, attendanceData, leadIndicatorData, performanceData, profileLoading, attendanceLoading, leadIndicatorDataLoading, performanceLoading]);

    const profilePicture = user?.profilePicture || UserProfileUserIcon;
    const performanceResidency =
        user?.performanceResidency?.performance && user?.performanceResidency?.residency
            ? `${user.performanceResidency.performance.charAt(0).toUpperCase() +
            user.performanceResidency.performance.slice(1)
            }-${user.performanceResidency.residency.charAt(0).toUpperCase() + user.performanceResidency.residency.slice(1)}`
            : "Unknown-Unknown";
    const performanceColor = user?.performanceResidency?.color
        ? `#${user.performanceResidency.color.slice(2)}`
        : "#f0f0f0";

    const refetchAllData = () => {
        refetchProfile();
        refetchLastActive();
        refetchLeadIndicator({
            variables: {
                accountId: parseInt(accountId),
                jobroleId: parseInt(roleId),
                userId: selectedUserId,
                startDate: getDateRangeLead.startDate,
                endDate: getDateRangeLead.endDate,
            },
        });
        refetchAttendance({
            variables: { userId: selectedUserId, startDate: getDateRangeAttendance.startDate, endDate: getDateRangeAttendance.endDate },
        });
        refetchPerformance({
            variables: { userId: selectedUserId, fromMonth: getDateRangePerformance.startDate, toMonth: getDateRangePerformance.endDate },
        });
        refetchProjectTime({
            variables: { userId: selectedUserId, startDate: getDateRangeLead.startDate, endDate: getDateRangeLead.endDate },
        });
        fetchNotifications({
            variables: {
                userId: selectedUserId,
                pagingCriteria: { limit, cursor: cursor || undefined, sortByField: "created_at", sortOrder: "desc" },
            },
        });

    };

    const formatPerformanceMonth = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "-";
        return new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" }).format(date);
    };

    if (hasError || !user) {
        return (
            <div className="error">
                {hasError
                    ? `Error: ${profileError?.message ||
                    lastActiveError?.message ||
                    leadIndicatorDataError?.message ||
                    attendanceError?.message ||
                    performanceError?.message ||
                    notificationError?.message}`
                    : ""}
            </div>
        );
    }

    const isLoading =
        profileLoading ||
        userListLoading ||
        lastActiveLoading ||
        leadIndicatorDataLoading ||
        attendanceLoading ||
        performanceLoading ||
        projectTimeLoading;

    // Show a full-page spinner until profile + key data are ready or user object is available
    if (isLoading || !user) {
        return renderLoading();
    }

    return (
        <>
            <div className="user-profile-container" ref={scrollRef} style={{ overflowY: "auto", maxHeight: "100vh" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontWeight: "500",
                            cursor: "pointer",
                        }}
                        onClick={() =>
                            navigate("/clan-crew-user-management", { state: { name, accountName, roleId, accountId } })
                        }
                    >
                        <img src={backIcon} alt="Back" style={{ marginRight: 8, height: "12px", width: "9px" }} />
                        <span style={{ fontSize: "18px", fontWeight: "600", fontFamily: "Inter", cursor: "pointer" }}>User Profile</span>
                    </div>
                    <div className="notificationGroup">

                        <button
                            className="viewHistory"
                            onClick={() => navigate(`/understand-user/${selectedUserId}`, {
                                state: {
                                    // Basic Info
                                    name: user.name,
                                    surname: user.surname || "",
                                    profilePicture: user.reporting?.profilePicture || user.profilePicture,

                                    // Date of Birth (for age calculation)
                                    dateOfBirth: user.dateOfBirth || null,

                                    // Tenure
                                    joiningDate: user.joiningDate,

                                    // Manager
                                    manager: user.reporting?.name || "Not Assigned",

                                    // Performance-Residency
                                    performanceResidency: user.performanceResidency,

                                    // Language Preferences
                                    preferredLanguages: user.preferredLanguages || [],
                                    appLanguage: user.appLanguage?.language || null,

                                    // Identity
                                    employeeId: user.employeeId,

                                    // Optional: Extra context
                                    accountName,
                                    roleId,
                                    accountId,
                                    userId: selectedUserId
                                }
                            })}
                        >
                            Understand {user?.name || "User"}
                        </button>

                        {showPushVideos && (
                            <button
                                className="pushVideos"
                                style={{ marginRight: "10px" }}
                                onClick={() => setIsPushVideosModalVisible(true)} // Open PushVideosFromAdminPanel
                            >
                                Push Videos
                            </button>
                        )}
                        <button className="viewHistory" onClick={handleNotificationHistoryClick}>
                            Notification History
                        </button>
                        <button className="sendNotification" onClick={() => setShowSendNotificationModal(true)}>
                            Send Notification
                        </button>
                        {/* <button
                        className="viewHistory"
                        onClick={() => setIsAdvancedNotifVisible(true)}
                    >
                        Send Targeted Notification
                    </button> */}
                        {/* <button
                        className="sendNotification"
                        onClick={() => setIsNotificationSystem(true)}
                    >
                        Notification system
                    </button> */}
                    </div>
                </div>

                <Row gutter={[16, 16]}>
                    <Col span={4}>
                        <div className="user-list-container-user-profile">
                            <h3 className="user-list-title">Users</h3>
                            <div className="search-input-container">
                                <input
                                    type="text"
                                    placeholder="Search user"
                                    className="search-input-userProfile"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                                <SearchOutlined className="search-icon-userProfile" />
                            </div>
                            <div className="user-list-scrollable" ref={userListScrollRef} style={{ maxHeight: "calc(100vh - 150px)", overflowY: "auto" }}>
                                {userListLoading ? (
                                    <p style={{ fontFamily: "Inter", marginTop: "10px" }}>Loading users...</p>
                                ) : userListError ? (
                                    <p style={{ fontFamily: "Inter", marginTop: "10px", color: "red" }}>Error: {userListError.message}</p>
                                ) : filteredUsers.length > 0 ? (
                                    <ul className="user-list">
                                        {filteredUsers.map((user) => (
                                            <li
                                                key={user.id}
                                                className={user.id === selectedUserId ? "active-user" : ""}
                                                onClick={() => handleUserClick(user.id)}
                                            >
                                                <img
                                                    src={user.reporting?.profilePicture || UserProfileIcon}
                                                    alt={`${user.name}'s Profile`}
                                                    className="user-profile-icon"
                                                    onError={(e) => (e.target.src = UserProfileIcon)}
                                                />
                                                <span>{user.fullname}</span>
                                            </li>
                                        ))}
                                        {loadingMore && (
                                            <div style={{ textAlign: "center", padding: "10px", color: "#666" }}>
                                                Loading more users...
                                            </div>
                                        )}

                                        {!hasNextPage && filteredUsers.length > 10 && (
                                            <div style={{ textAlign: "center", padding: "10px", color: "#999", fontSize: "12px" }}>
                                                All users loaded
                                            </div>
                                        )}
                                    </ul>
                                ) : (
                                    <p style={{ fontFamily: "Inter", marginTop: "10px" }}>No users found.</p>
                                )}
                            </div>
                        </div>
                    </Col>

                    <Col span={20} style={{ paddingRight: "20px" }}>
                        <div className="user-details-container">
                            <div className="user-details-header">
                                <div className="user-info-userProfile">
                                    <ProfileImageUploader
                                        userId={selectedUserId}
                                        onImageUpdate={handleSaveCroppedImage}
                                        initialImage={localProfilePicture || profilePicture}
                                        resetTrigger={true}
                                    />
                                    <div className="user-info-details">
                                        <h3>{user.fullname}</h3>
                                        <p>{user.email}</p>
                                        <span className={`status-dot-userProfile ${statusDotClass}`}></span>
                                        <span className={`status ${statusDotClass}`}>{status}</span>
                                    </div>
                                </div>
                                {!isManagerOrSuperManager && (
                                    <div className="performance-container">
                                        <span className="performance-label">Performance-Residency</span>
                                        <span className="performance" style={{ backgroundColor: performanceColor }}>
                                            {performanceResidency}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <Card className="user-profile-card" bodyStyle={{ padding: "0px" }}>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <div className="basic-information">
                                        <h4 className="info-section-title">Basic Information</h4>
                                        <div className="info-content">
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Name</p>
                                                    <p className="info-value">{user.fullname}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Gender</p>
                                                    <p className="info-value">{user.gender || ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Date of Birth</p>
                                                    <p className="info-value">{formatDateToIndian(user.dateOfBirth)} {user.dateOfBirth ? `(${calculateAge(user.dateOfBirth)})` : ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Employee ID</p>
                                                    <p className="info-value">{user.employeeId || ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Email ID</p>
                                                    <p className="info-value">{user.email || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Highest Qualification</p>
                                                    <p className="info-value">{user.higestEducationQualification || ""}</p>

                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Previous Employer</p>
                                                    <p className="info-value">{user.previousEmployer || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Previous Experience</p>
                                                    <p className="info-value">
                                                        {user.previousExperience
                                                            ? (() => {
                                                                const totalMonths = parseInt(user.previousExperience, 10);
                                                                const years = Math.floor(totalMonths / 12);
                                                                const remainingMonths = totalMonths % 12;
                                                                if (years === 0) {
                                                                    return `${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
                                                                }
                                                                if (remainingMonths === 0) {
                                                                    return `${years} year${years !== 1 ? "s" : ""}`;
                                                                }
                                                                return `${years} year${years !== 1 ? "s" : ""} ${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
                                                            })()
                                                            : ""}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Phone Number</p>
                                                    <p className="info-value">{user.phoneNumber || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Preferred Languages</p>
                                                    <p className="info-value">
                                                        {user.preferredLanguages && user.preferredLanguages.length > 0
                                                            ? user.preferredLanguages.map((lang) => lang.name).join(", ")
                                                            : "No languages specified"}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="work-information">
                                        <h4 className="info-section-title">Work Information</h4>
                                        <div className="info-content">
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Employment Type</p>
                                                    <p className="info-value">{user.employeeType || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Date of Joining</p>
                                                    <p className="info-value">{formatDateToIndian(user.joiningDate)} {user.joiningDate ? `(${calculateYearsOfService(user.joiningDate)})` : ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Current Designation</p>
                                                    <p className="info-value">{user.designation || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Branch</p>
                                                    <p className="info-value">{user.branch || ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">State, City</p>
                                                    <p className="info-value">{user.stateName || ""}, {user.cityName || ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Login Type</p>
                                                    <p className="info-value">{user.userType?.userType ?? ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item">
                                                    <p className="info-label">Manager Name</p>
                                                    <p className="info-value">{user.reporting?.name ?? ""}</p>
                                                </div>
                                                <div className="info-item">
                                                    <p className="info-label">Manager ID</p>
                                                    <p className="info-value">{user.reporting?.employeeId ?? ""}</p>
                                                </div>
                                            </div>
                                            <div className="info-row">
                                                <div className="info-item full-width">
                                                    <p className="info-label">Date of Reporting</p>
                                                    <p className="info-value">{formatDateToIndian(user.reportingDate)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {!isManagerOrSuperManager && (
                                <>
                                    <div style={{
                                        backgroundColor: "white", marginTop: "16px", padding: "10px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                    }}>
                                        <div className="filters">
                                            <span className="filterName">Filters</span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "This month" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("This month")}
                                            >
                                                This month
                                            </span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "Last month" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("Last month")}
                                            >
                                                Last month
                                            </span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "Last 3 months" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("Last 3 months")}
                                            >
                                                Last 3 months
                                            </span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "Last 6 months" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("Last 6 months")}
                                            >
                                                Last 6 months
                                            </span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "Last Year" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("Last Year")}
                                            >
                                                Last Year
                                            </span>
                                            <span
                                                className={`filter ${activeFilterAttendance === "Custom" ? "active" : ""}`}
                                                onClick={() => handleFilterClickAttendance("Custom")}
                                            >
                                                Custom
                                            </span>
                                            {showDateRangePopupAttendance && (
                                                <>
                                                    <div className={`date-range-overlay ${showDateRangePopupAttendance ? "active" : ""}`}></div>
                                                    <div className={`date-range-popup date-range-popup-attendance ${showDateRangePopupAttendance ? "active" : ""}`}>
                                                        <div className="popup-content">
                                                            <label>
                                                                <span className="fromText">From:</span>
                                                                <input
                                                                    type="date"
                                                                    name="from"
                                                                    value={dateRangeAttendance.from}
                                                                    onChange={handleDateChangeAttendance}
                                                                    max={dateRangeAttendance.to || today}
                                                                />
                                                            </label>
                                                            <label>
                                                                <span className="fromText"> To:</span>
                                                                <input
                                                                    type="date"
                                                                    name="to"
                                                                    value={dateRangeAttendance.to}
                                                                    onChange={handleDateChangeAttendance}
                                                                    min={dateRangeAttendance.from}
                                                                    max={today}
                                                                />
                                                            </label>
                                                            <div className="popup-actions">
                                                                <button onClick={handleApplyDateRangeAttendance} className={`dateRangeApply ${dateRangeAttendance.from && dateRangeAttendance.to ? "enabled" : ""}`}
                                                                    disabled={!dateRangeAttendance.from || !dateRangeAttendance.to}>Apply</button>
                                                                <button onClick={handleCancelAttendance} className="dateRangeCancel">Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <Row gutter={[17, 17]} style={{ marginTop: "16px" }}>
                                        <Col span={24}>
                                            <div className="attendance-summary">
                                                <div className="attendance-summary-header">
                                                    <h4 className="info-section-title">Attendance Summary (
                                                        {activeFilterAttendance === "Custom" && appliedDateRangeAttendance.from && appliedDateRangeAttendance.to
                                                            ? `${formatDateToIndian(appliedDateRangeAttendance.from)} - ${formatDateToIndian(appliedDateRangeAttendance.to)}`
                                                            : activeFilterAttendance === "This month"
                                                                ? `${formatDateToIndian(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'))} - ${formatDateToIndian(new Date().toLocaleDateString('en-CA'))}`
                                                                : (() => {
                                                                    const startDate = new Date(getDateRangeAttendance.startDate);
                                                                    const endDate = new Date(getDateRangeAttendance.endDate);
                                                                    const startMonth = startDate.toLocaleString("en-US", { month: "short" });
                                                                    const startYear = startDate.getFullYear().toString().slice(-2);
                                                                    const endMonth = endDate.toLocaleString("en-US", { month: "short" });
                                                                    const endYear = endDate.getFullYear().toString().slice(-2);
                                                                    const startMonthYear = `${startMonth} '${startYear}`;
                                                                    const endMonthYear = `${endMonth} '${endYear}`;
                                                                    return startMonthYear === endMonthYear ? startMonthYear : `${startMonthYear} - ${endMonthYear}`;
                                                                })()}
                                                        )</h4>
                                                </div>
                                                <div className="attendance-cards-container">
                                                    <div className="attendance-cards">
                                                        <div className="attendance-card-userProfile">
                                                            <div className="card-content">
                                                                <div className="card-icon">
                                                                    <PresentDays style={{ width: "40px", height: "40px" }} />
                                                                </div>
                                                            </div>
                                                            <div className="card-text">
                                                                <p className="allDaysHeadings">Present Days</p>
                                                                <h3>{attendanceSummary.presentDays}</h3>
                                                            </div>
                                                        </div>
                                                        <div className="attendance-card-userProfile">
                                                            <div className="card-content">
                                                                <div className="card-icon">
                                                                    <ComplianceDays style={{ width: "40px", height: "40px" }} />
                                                                </div>
                                                            </div>
                                                            <div className="card-text">
                                                                <p className="allDaysHeadings">Compliance Days</p>
                                                                <h3>{attendanceSummary.complianceDays}</h3>
                                                            </div>
                                                        </div>
                                                        <div className="attendance-card-userProfile">
                                                            <div className="card-content">
                                                                <div className="card-icon">
                                                                    <LeaveIcon style={{ width: "40px", height: "40px" }} />
                                                                </div>
                                                            </div>
                                                            <div className="card-text">
                                                                <p className="allDaysHeadings">Days On Leave</p>
                                                                <h3>{attendanceSummary.daysOnLeave}</h3>
                                                            </div>
                                                        </div>
                                                        <div className="attendance-card-userProfile">
                                                            <div className="card-content">
                                                                <div className="card-icon">
                                                                    <HolidayIconActivate style={{ width: "40px", height: "40px" }} />
                                                                </div>
                                                            </div>
                                                            <div className="card-text">
                                                                <p className="allDaysHeadings">Holiday</p>
                                                                <h3>{attendanceSummary.holidays}</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="attendance-legend">
                                                    <span className="legend-items"><span className="status-dots signed-in"></span>Signed In</span>
                                                    <span className="legend-items"><span className="status-dots signed-out"></span>Signed Out</span>
                                                    <span className="legend-items"><span className="status-dots work-data"></span>Work Data</span>
                                                    <span className="legend-items"><span className="status-dots time-distribution"></span>Time Distribution</span>
                                                    <span className="legend-items"><span className="status-dots on-leave"></span>On Leave</span>
                                                    <span className="legend-items"><span className="status-dots holiday"></span>Holiday</span>
                                                </div>
                                                <div className="attendance-table">
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    <span className="icon"></span> Date
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Day
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Signed In
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Signed Out
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Work Data
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Time Distribution
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Leave
                                                                </th>
                                                                <th>
                                                                    <span className="icon"></span> Holiday
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {attendanceData?.getAttendanceDetailsForATimePeriod ? (
                                                                Array.isArray(attendanceData.getAttendanceDetailsForATimePeriod) ? (
                                                                    attendanceData.getAttendanceDetailsForATimePeriod.length > 0 ? (
                                                                        [...attendanceData.getAttendanceDetailsForATimePeriod]
                                                                            .sort((a, b) => {
                                                                                const today = new Date();
                                                                                const dateA = new Date(a.inputDate);
                                                                                const dateB = new Date(b.inputDate);
                                                                                if (dateA.toDateString() === today.toDateString()) return -1;
                                                                                if (dateB.toDateString() === today.toDateString()) return 1;
                                                                                return dateB - dateA;
                                                                            })
                                                                            .map((day, index) => (
                                                                                <tr
                                                                                    key={index}
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            new Date(day.inputDate).toDateString() === new Date().toDateString()
                                                                                                ? '#FDEDED'
                                                                                                : 'inherit',
                                                                                    }}
                                                                                >
                                                                                    <td>{formatDateToIndian(day.inputDate)}</td>
                                                                                    <td>{day.inputDate ? new Date(day.inputDate).toLocaleDateString("en-US", { weekday: "long" }) : "-"}</td>
                                                                                    <td>{day.didSignIn ? <SignedInIcon /> : <SignedDisableIcon />}</td>
                                                                                    <td>{day.didSignOut ? <SignedOutIcon /> : <SignedDisableIcon />}</td>
                                                                                    <td>{day.didInput ? <WorkedDataIcon /> : <WorkedDataIconDisable />}</td>
                                                                                    <td>{day.givenTimeDistribution ? <TimeDistributionIcon /> : <TimeDistributionIconDisable />}</td>
                                                                                    <td>{day.isLeave ? <LeaveIcon /> : <LeaveIconDisable />}</td>
                                                                                    <td>{day.isHoliday ? <HolidayIconActivate /> : <HolidayIconDisable />}</td>
                                                                                </tr>
                                                                            ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan={8}>No attendance data available</td>
                                                                        </tr>
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={8}>Invalid attendance data format</td>
                                                                    </tr>
                                                                )
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={8}>Loading attendance data...</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <div className="lead-indicator-data">
                                                <div className="lead-indicator-header">
                                                    <h4 className="info-section-title">Lead Indicator Data (
                                                        {activeFilterLead === "Custom" && appliedDateRangeLead.from && appliedDateRangeLead.to
                                                            ? `${formatDateToIndian(appliedDateRangeLead.from)} - ${formatDateToIndian(appliedDateRangeLead.to)}`
                                                            : activeFilterLead === "This month"
                                                                ? `${formatDateToIndian(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'))} - ${formatDateToIndian(new Date().toLocaleDateString('en-CA'))}`
                                                                : (() => {
                                                                    const startDate = new Date(getDateRangeLead.startDate);
                                                                    const endDate = new Date(getDateRangeLead.endDate);
                                                                    const startMonth = startDate.toLocaleString("en-US", { month: "short" });
                                                                    const startYear = startDate.getFullYear().toString().slice(-2);
                                                                    const endMonth = endDate.toLocaleString("en-US", { month: "short" });
                                                                    const endYear = endDate.getFullYear().toString().slice(-2);
                                                                    const startMonthYear = `${startMonth} '${startYear}`;
                                                                    const endMonthYear = `${endMonth} '${endYear}`;
                                                                    return startMonthYear === endMonthYear ? startMonthYear : `${startMonthYear} - ${endMonthYear}`;
                                                                })()}
                                                        )</h4>
                                                </div>
                                                <div className="info-content">
                                                    <table className="lead-indicator-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Lead Indicators</th>
                                                                <th>Actuals</th>
                                                                <th>Targets</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {leadIndicatorDataLoading ? (
                                                                <tr>
                                                                    <td colSpan={3}>Loading...</td>
                                                                </tr>
                                                            ) : leadIndicatorDataError ? (
                                                                <tr>
                                                                    <td colSpan={3}>Error loading data: {leadIndicatorDataError.message}</td>
                                                                </tr>
                                                            ) : leadIndicatorDataResult.length > 0 ? (
                                                                leadIndicatorDataResult.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.kiiName || "-"}</td>
                                                                        <td>{item.value?.totalValue ?? "-"}</td>
                                                                        <td>{item.value?.totalTarget ?? "-"}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3}>No data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col span={24}>
                                            <div className="lead-indicator-data">
                                                <div className="lead-indicator-header">
                                                    <h4 className="info-section-title">Time Distribution (
                                                        {activeFilterLead === "Custom" && appliedDateRangeLead.from && appliedDateRangeLead.to
                                                            ? `${formatDateToIndian(appliedDateRangeLead.from)} - ${formatDateToIndian(appliedDateRangeLead.to)}`
                                                            : activeFilterLead === "This month"
                                                                ? `${formatDateToIndian(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'))} - ${formatDateToIndian(new Date().toLocaleDateString('en-CA'))}`
                                                                : (() => {
                                                                    const startDate = new Date(getDateRangeLead.startDate);
                                                                    const endDate = new Date(getDateRangeLead.endDate);
                                                                    const startMonth = startDate.toLocaleString("en-US", { month: "short" });
                                                                    const startYear = startDate.getFullYear().toString().slice(-2);
                                                                    const endMonth = endDate.toLocaleString("en-US", { month: "short" });
                                                                    const endYear = endDate.getFullYear().toString().slice(-2);
                                                                    const startMonthYear = `${startMonth} '${startYear}`;
                                                                    const endMonthYear = `${endMonth} '${endYear}`;
                                                                    return startMonthYear === endMonthYear ? startMonthYear : `${startMonthYear} - ${endMonthYear}`;
                                                                })()}
                                                        )</h4>
                                                </div>
                                                <div className="info-content">
                                                    <table className="lead-indicator-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>Norm</th>
                                                                {/* <th>Depends</th> */}
                                                                <th>User Value</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {projectTimeLoading ? (
                                                                <tr>
                                                                    <td colSpan={4}>Loading...</td>
                                                                </tr>
                                                            ) : projectTimeError ? (
                                                                <tr>
                                                                    <td colSpan={4}>Error loading data: {projectTimeError.message}</td>
                                                                </tr>
                                                            ) : sortedProjectTimeData.length > 0 ? (
                                                                sortedProjectTimeData.map((item, index) => (
                                                                    <tr key={item.id}>
                                                                        <td>{item.projectName || ""}</td>
                                                                        <td>{formatSecondsToTime(item.projectNorm)}</td>
                                                                        {/* <td>{formatDepends(item.depends)}</td> */}
                                                                        <td>{formatSecondsToTime(item.userValue)}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4}>No project time data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <div className="performance-data">
                                                <div className="lead-indicator-header">
                                                    <h4 className="info-section-title">
                                                        Performance Data (
                                                        {activeFilterPerformance === "Custom" && appliedDateRangePerformance.from && appliedDateRangePerformance.to
                                                            ? `${formatDateToIndian(appliedDateRangePerformance.from)} - ${formatDateToIndian(appliedDateRangePerformance.to)}`
                                                            : activeFilterPerformance === "This month"
                                                                ? `${formatDateToIndian(new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'))} - ${formatDateToIndian(new Date().toLocaleDateString('en-CA'))}`
                                                                : (() => {
                                                                    const startDate = new Date(getDateRangePerformance.startDate);
                                                                    const endDate = new Date(getDateRangePerformance.endDate);
                                                                    const startMonth = startDate.toLocaleString("en-US", { month: "short" });
                                                                    const startYear = startDate.getFullYear().toString().slice(-2);
                                                                    const endMonth = endDate.toLocaleString("en-US", { month: "short" });
                                                                    const endYear = endDate.getFullYear().toString().slice(-2);
                                                                    const startMonthYear = `${startMonth} '${startYear}`;
                                                                    const endMonthYear = `${endMonth} '${endYear}`;
                                                                    return startMonthYear === endMonthYear ? startMonthYear : `${startMonthYear} - ${endMonthYear}`;
                                                                })()}
                                                        )
                                                    </h4>
                                                </div>
                                                <div className="info-content">
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                                        {performanceLoading ? (
                                                            <p>Loading performance data...</p>
                                                        ) : performanceError ? (
                                                            <p>Error loading performance data: {performanceError.message}</p>
                                                        ) : !performanceData?.getUserPerformanceDataForMonths ||
                                                            performanceData.getUserPerformanceDataForMonths.length === 0 ||
                                                            performanceData.getUserPerformanceDataForMonths.every(item => !item.performance && !item.performanceMonth) ? (
                                                            <p style={{ fontFamily: "Inter" }}>No performance data available for the selected period.</p>
                                                        ) : (
                                                            <>
                                                                {/* Only show chart if there is actual data */}
                                                                {!performanceData.getUserPerformanceDataForMonths.every(item =>
                                                                    item.performanceMetric === null && item.performanceLabel === null
                                                                ) && (
                                                                        <div style={{ position: "relative", height: "200px", width: "350px", display: "flex", justifyContent: "center" }}>
                                                                            <PieChart width={350} height={200}>
                                                                                <RechartsPie
                                                                                    data={pieData}
                                                                                    dataKey="value"
                                                                                    paddingAngle={1}
                                                                                    labelLine={false}
                                                                                    label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                                                                                        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                                                                                        const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                                                                                        const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                                                                                        return percent > 0 ? (
                                                                                            <text
                                                                                                x={x}
                                                                                                y={y}
                                                                                                fill="#fff"
                                                                                                textAnchor="middle"
                                                                                                dominantBaseline="central"
                                                                                                fontSize="12px"
                                                                                                fontFamily="Inter"
                                                                                            >
                                                                                                {`${(percent * 100).toFixed(0)}%`}
                                                                                            </text>
                                                                                        ) : null;
                                                                                    }}
                                                                                >
                                                                                    <Cell fill="#D73838" /> {/* LOW */}
                                                                                    <Cell fill="#2E96FF" /> {/* MEDIUM */}
                                                                                    <Cell fill="#49A44A" /> {/* HIGH */}
                                                                                </RechartsPie>

                                                                                <Tooltip formatter={(value) => `${value}%`} />
                                                                                <Legend
                                                                                    layout="vertical"
                                                                                    align="right"
                                                                                    verticalAlign="middle"
                                                                                    wrapperStyle={{ paddingLeft: "20px" }}
                                                                                    formatter={(value) => (
                                                                                        <span style={{ color: "#1a1a1a", fontFamily: "Inter" }}>{value}</span>
                                                                                    )}
                                                                                />
                                                                            </PieChart>
                                                                        </div>
                                                                    )}

                                                                {/* Performance table - only show if has data */}
                                                                {performanceData?.getUserPerformanceDataForMonths &&
                                                                    performanceData.getUserPerformanceDataForMonths.length > 0 && (
                                                                        <div
                                                                            style={{ width: "100%", marginTop: "20px", fontFamily: "Inter" }}
                                                                            className="performance-table"
                                                                        >
                                                                            <table
                                                                                style={{
                                                                                    width: "100%",
                                                                                    borderCollapse: "collapse",
                                                                                    fontFamily: "Inter",
                                                                                    fontSize: "14px",
                                                                                    border: "1px solid #e8e8e8",
                                                                                }}
                                                                            >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th
                                                                                            style={{
                                                                                                textAlign: "left",
                                                                                                padding: "8px",
                                                                                                fontWeight: "600",
                                                                                                border: "1px solid #e8e8e8",
                                                                                                backgroundColor: "#fafafa",
                                                                                            }}
                                                                                        >
                                                                                            Month
                                                                                        </th>
                                                                                        <th
                                                                                            style={{
                                                                                                textAlign: "center",
                                                                                                padding: "8px",
                                                                                                fontWeight: "600",
                                                                                                border: "1px solid #e8e8e8",
                                                                                                backgroundColor: "#fafafa",
                                                                                            }}
                                                                                        >
                                                                                            Overall Achievement
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {performanceData.getUserPerformanceDataForMonths.map((item, index) => (
                                                                                        <tr key={index}>
                                                                                            <td
                                                                                                style={{
                                                                                                    padding: "8px",
                                                                                                    border: "1px solid #e8e8e8",
                                                                                                }}
                                                                                            >
                                                                                                {formatPerformanceMonth(item.performanceMonth)}
                                                                                            </td>
                                                                                            <td
                                                                                                style={{
                                                                                                    textAlign: "center",
                                                                                                    padding: "8px",
                                                                                                    border: "1px solid #e8e8e8",
                                                                                                }}
                                                                                            >
                                                                                                {item.performance || ""}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Card>
                        {/* <button className="removeProfile" onClick={handleRemoveProfile} disabled={loading}>
                            Remove Profile
                        </button> */}
                        <Modal
                            open={showConfirmModal}
                            footer={null}
                            closable={false}
                            centered
                            width={500}
                        >
                            <p className="deleteConfirm">Do you want to remove <span className="deleteConfirmSpan">{user.name}</span> from user profile?</p>
                            <div className="YesandNoConfirmButtons">
                                <button
                                    onClick={handleConfirmRemove}
                                    disabled={loading}
                                    className="deleteYesButton"
                                    style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                                >
                                    {loading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Yes'}
                                </button>
                                <button
                                    className="deleteNoButton"
                                    onClick={handleCancelRemove}
                                    style={{ marginRight: "10px" }}
                                >
                                    No
                                </button>
                            </div>
                        </Modal>
                    </Col>
                </Row>

                <SendNotificationModal
                    visible={showSendNotificationModal}
                    onCancel={() => setShowSendNotificationModal(false)}
                    userId={selectedUserId}
                    userName={(user?.surname || "") + " " + (user?.name || "")}
                />

                <EditUserModal
                    visible={isEditModalVisible}
                    onCancel={() => setIsEditModalVisible(false)}
                    userId={selectedUserId}
                    userData={user}
                    roleId={roleId}
                    accountId={accountId}
                    refetch={refetchAllData}
                />

                <PushVideosFromAdminPanel
                    visible={isPushVideosModalVisible}
                    onCancel={() => setIsPushVideosModalVisible(false)}
                    userId={selectedUserId}
                    userData={user}
                    leadIndicatorData={leadIndicatorData}
                    getDateRangeLead={getDateRangeLead}
                />

                {/* Understand User Profile Modal */}
                {/* Understand User Profile Modal */}
                <Modal
                    open={isUnderstandUserModalVisible}
                    onCancel={() => setIsUnderstandUserModalVisible(false)}
                    footer={null}
                    width={1100}
                    centered
                    destroyOnClose={true}
                    className="understand-user-modal"
                    closeIcon={<div style={{ color: "#AD0101", fontSize: "30px" }}>×</div>}
                >
                    {user && (
                        <ClanCrewUnderstandUserProfile
                            user={{
                                id: user.id,
                                name: `${user.name} ${user.surname || ""}`.trim(),
                                profilePicture: user.profilePicture || "https://ui-avatars.com/api/?name=" + encodeURIComponent(user.name) + "&background=6366f1&color=fff&size=200",
                                age: user.dateOfBirth ? parseInt(calculateAge(user.dateOfBirth)) : "N/A",
                                tenure: user.joiningDate ? calculateYearsOfService(user.joiningDate) : "N/A",
                                performance: {
                                    bracket: user.performanceResidency?.performance || "Unknown",
                                    outcomePercentage: user.performanceResidency?.percentage || 0
                                },
                                preferences: {
                                    appLanguage: user.preferredLanguages?.map(l => l.name).join(", ") || "",
                                    videoLanguage: ""
                                },
                                deviceDetails: {
                                    type: "",   // You can enhance later
                                    model: "",
                                    osVersion: ""
                                },
                                manager: {
                                    name: user.reporting?.name || "Not assigned",
                                    email: user.reporting?.email || ""
                                },
                                behaviouralInsights: [] // Optional: populate later from real data
                            }}
                        />
                    )}
                </Modal>

                <Modal
                    open={isPopupVisible}
                    onCancel={handlePopupClose}
                    footer={null}
                    closable={true}
                    centered
                    className="profile-popup-modal"
                    width={400}
                >
                    <div className="profile-popup-content">
                        <img
                            src={profilePicture}
                            alt="Enlarged Profile"
                            className="profile-popup-image"
                            style={{ width: "100%", height: "auto", borderRadius: "8px" }}
                        />
                        <h3 style={{ fontFamily: "Inter", textAlign: "center", marginTop: "16px" }}>{user.name}</h3>
                        <p style={{ fontFamily: "Inter", textAlign: "center", color: "#666" }}>{user.email}</p>
                        <div style={{ textAlign: "center", marginTop: "16px" }}>
                            <span className={`status-dot ${statusDotClass}`}></span>
                            <span className={`status ${statusDotClass}`} style={{ marginLeft: "8px" }}>
                                {status}
                            </span>
                        </div>
                    </div>
                </Modal>

                <ClanCrewAdvancedNotificationModal
                    visible={isAdvancedNotifVisible}
                    onCancel={() => setIsAdvancedNotifVisible(false)}
                    users={userListData?.getUsersForAccount?.data || []}
                    roleId={roleId}
                    accountId={accountId}
                />

                {/* <NotificationSystem
                visible={isNotificationSystem}
                onCancel={() => setIsNotificationSystem(false)}
                // users={userListData?.getUsersForAccount?.data || []}
                // roleId={roleId}
                // accountId={accountId}
            /> */}

                <Modal
                    open={isNotificationVisible}
                    onCancel={handleNotificationClose}
                    footer={null}
                    closable={true}
                    centered
                    className="notification-popup-modal"
                    width={500}
                >
                    <div className="notification-popup-content">
                        <h3 style={{ fontFamily: "Inter", textAlign: "center", marginBottom: "20px" }}>New Notification</h3>
                        <div style={{ marginBottom: "15px" }}>
                            <label style={{ fontFamily: "Inter", fontSize: "14px", marginBottom: "5px", display: "block" }}>Title</label>
                            <Input.TextArea
                                value={notificationMessage}
                                onChange={(e) => setNotificationMessage(e.target.value)}
                                placeholder="Enter title..."
                                autoSize={{ minRows: 3, maxRows: 5 }}
                                style={{ fontFamily: "Inter", resize: "vertical" }}
                            />
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <label style={{ fontFamily: "Inter", fontSize: "14px", marginBottom: "5px", display: "block" }}>
                                Description
                            </label>
                            <Input.TextArea
                                value={notificationDetails}
                                onChange={(e) => setNotificationDetails(e.target.value)}
                                placeholder="Enter description..."
                                autoSize={{ minRows: 3, maxRows: 5 }}
                                style={{ fontFamily: "Inter", resize: "vertical" }}
                            />
                        </div>
                        <div className="sendAndCancelMessage">
                            <button
                                className="cancelMessage"
                                onClick={handleNotificationClose}
                                style={{ marginRight: "10px", fontFamily: "Inter", fontSize: "14px" }}
                            >
                                Cancel
                            </button>
                            <button
                                className={`sendMessage ${createNewNotificationLoading ? 'disabled' : ''}`}
                                onClick={handleSendNotification}
                                disabled={createNewNotificationLoading}
                                style={{ fontFamily: "Inter", fontSize: "14px" }}
                            >
                                {createNewNotificationLoading ? "Sending..." : "Send"}
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal
                    open={isNotificationHistoryVisible}
                    onCancel={handleNotificationHistoryClose}
                    footer={null}
                    closable={true}
                    centered
                    className="notification-history-modal"
                    width={800}
                >
                    <div className="notification-history-content">
                        <h3 className="text-center font-inter text-xl font-semibold mb-5">Notification History</h3>
                        {notificationLoading ? (
                            <p className="text-center font-inter">Loading notifications...</p>
                        ) : notificationError ? (
                            <p className="text-center text-red-500 font-inter">Error: {notificationError.message}</p>
                        ) : notificationDataSource.length === 0 ? (
                            <p className="text-center font-inter">No notifications available.</p>
                        ) : (
                            <>
                                <Table
                                    columns={notificationColumns}
                                    dataSource={notificationDataSource}
                                    rowKey="id"
                                    pagination={false}
                                    bordered
                                    className="notification-table-userProfile"
                                />
                                <div className="pagination-container-userProfile">
                                    <img
                                        src={PaginationPrevious}
                                        onClick={() => handlePageChange("prev")}
                                        className={`pagination-button-userProfile ${currentPage === 1 ? "disabled" : ""}`}
                                        alt="Previous Page"
                                        style={{ height: "18px", width: "18px" }}
                                    />
                                    <span className="pagination-info-userProfile">
                                        Page <span className="page-number">{currentPage}</span> of <span className="page-number">{totalPages}</span>
                                    </span>
                                    <img
                                        src={PaginationNext}
                                        onClick={() => handlePageChange("next")}
                                        className={`pagination-button-userProfile ${!hasNext ? "disabled" : ""}`}
                                        alt="Next Page"
                                        style={{ height: "18px", width: "18px" }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </Modal>

            </div>
        </>
    );
};

export default ClanCrewUserProfile;